import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import ProdutoForm from '../components/ProdutoForm';
import { getTemPermissao, getUsuario, getTipoUsuario } from "../utils/LoginManager";
import { resolveImageUrl } from "../utils/Storage";
import Colors from '../utils/Colors';
import moment from "moment-timezone";

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
  };

  componentDidMount() {
    const usuario = getUsuario();
    getTipoUsuario().then(tipoUsuario => {
      this.setState({
        tipoUsuario,
        usuario,
      },
        this.getListaRegistros()
      );
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true });
    const { busca, pagina, limite } = this.state;
    axios
      .get('/produtos', {
        params: {
          page: pagina,
          limite: limite,
          avancada: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.prod_idf) {
      request = axios.put(`/produtos/update/${registro.prod_idf}`, registro);
    } else {
      request = axios.post(`/produtos/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Produto gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/produtos/show/${registro.prod_idf}`)
      .then(response => {
        const { data } = response;

        data.prod_grupo = {
          key: data.prod_grupo,
          label: data.grp_descricao,
        }
        data.prod_marca = {
          key: data.prod_marca,
          label: data.mar_descricao,
        }
        data.prod_medida = {
          key: data.prod_medida,
          label: data.med_descricao1,
        }
        data.prod_medida2 = {
          key: data.prod_medida2,
          label: data.med_descricao2,
        }

        data.base64 = '';
        data.pathImagem = data.prod_imagem ? resolveImageUrl(`emp${this.state.usuario.emp_codigo}/produtos/${data.prod_imagem}`) : '';
        // data.pathImagem = data.prod_imagem ? resolveImageUrl(`emp${this.state.usuario.emp_codigo}/produtos/${data.prod_idf}.${data.prod_imagem}`) : '';

        // console.log('IMAGEM: ', data.pathImagem);

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/produtos/delete/${registro.prod_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.prod_idf === registro.prod_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        imgNome: '',
        imgSize: '0',
        imgData: '',
        base64: '',
        pathImagem: "",
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/produtos/ativa/${registro.prod_idf}/1`)
    } else {
      request = axios.put(`/produtos/ativa/${registro.prod_idf}/0`)
    }

    request.then(response => {
      registro.prod_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderAtiva = (prod_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={prod_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        disabled={getTemPermissao('ProdutosPage', 'editar') ? false : true}
        style={{ backgroundColor: !prod_situacao ? null : Colors.primary }}
      />
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar" placement="left">
          <Button className="botoesModalFormEditar" disabled={getTemPermissao('ProdutosPage', 'editar') ? false : true} size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir" placement="right">
          <Button className="botoesModalFormExcluir" disabled={getTemPermissao('ProdutosPage', 'excluir') ? false : true} size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    // console.log('ProdutosPage: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Cadastro de Produtos</h2>
        <hr />
        <br />

        <div className="pageFiltro">
          {(!this.state.tipoUsuario) || (getTemPermissao('ProdutosPage', 'novo')) ? (
            <Button
              onClick={this.onAdicionarClick}
              className="pageFiltro-adicionar"
            >
              Adicionar
            </Button>
          ) : null}

          <Search
            placeholder="Buscar por Descrição"
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <ProdutoForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          // scroll={{ x: 600 }}
          rowKey={(registro => registro.prod_idf)}
        >
          <Column
            key="prod_codigo"
            dataIndex="prod_codigo"
            title="Código"
            width={"5%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="prod_descricao"
            dataIndex="prod_descricao"
            title="Descrição"
            width={"25%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="med_descricao"
            dataIndex="med_descricao"
            title="Medida"
            width={"8%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="mar_descricao"
            dataIndex="mar_descricao"
            title="Marca"
            width={"10%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="grp_descricao"
            dataIndex="grp_descricao"
            title="Grupo"
            width={"10%"}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="prod_data_atu"
            dataIndex="prod_data_atu"
            title="Data Atu"
            render={this.renderData}
            width={"10%"}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="prod_situacao"
            dataIndex="prod_situacao"
            title="Situação"
            render={this.renderAtiva}
            width={"5%"}
            align="center"
            className="listaCadastro"
          />
          {getTemPermissao('ProdutosPage', 'editar') || getTemPermissao('ProdutosPage', 'excluir') ? (
            <Column
              key="acoes"
              title="Ações"
              render={this.renderAcoes}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
          ) : null}
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProdutosPage.js